define([
	"dojo/_base/declare",
	"csi/heading/String",
	"./_base"
], function(declare,StringRen,MappingBase) {

	return declare(StringRen, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: switch to MerchProductSubtypeSettings if exists
			var viewNode = ctx.view.getViewNode();
			var mappingNode = viewNode.SetupSettings ? ctx.cache.getNode(viewNode.SetupSettings, true) : viewNode;
			ctx.pushParams().setNodeURL(mappingNode.$URL);

			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context
			ctx.pop();
			this.inherited(arguments);
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			var nodeConfigurableAttribute = ctx.getNodeContext();
			var nodeSettings = ctx.getNode();

			var key = MappingBase.getMappingKey(nodeConfigurableAttribute);
			var index = MappingBase.findMappingKeyInSettings(nodeSettings, key);

			return (index >= 0) ? nodeSettings.ProductAttributeMappingExpressions[index] : "";
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported DE27181
			return null;
		}
	});
});